module.exports = __webpack_public_path__ + "img/maverick-full.138eb24b.png";